export const UserLandedOnFarmer360 = 'UserLandedOnFarmer360'
export const Farmer360UserInformationAdded = 'Farmer360UserInformationAdded'
export const FarmerListUserInitiatedSearch='FarmerListUserInitiatedSearch'